import React from "react";
import styles from "../Input/TextField/TextField.module.css";
import { labelName } from "../../utils";

export default function FormSection({ title }) {
  return (
    <>
      <h2 className={styles.sectionTitle}>{labelName(title)}</h2>
    </>
  );
}
